import { Injectable, inject, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { VersionService } from './version.service';

@Injectable({
  providedIn: 'root'
})
export class ChunkErrorHandlerService implements ErrorHandler {
  private readonly versionService = inject(VersionService);
  
  handleError(error: any): void {
    // Check if this is a chunk loading error
    if (this.isChunkLoadError(error)) {
      console.warn('Chunk loading error detected, checking for updates...', error);
      
      // Trigger an immediate version check
      this.versionService.checkForUpdates();
    }
    
    // Re-throw the error so Angular's default error handler can still process it
    // Remove this if you want to suppress chunk load errors completely
    throw error;
  }
  
  private isChunkLoadError(error: any): boolean {
    // Common patterns for chunk loading errors
    const errorString = error?.toString?.() || '';
    const errorMessage = error?.message || '';
    
    return (
      // Loading chunk failed
      errorString.includes('Loading chunk') ||
      errorString.includes('ChunkLoadError') ||
      
      // CSS chunk loading
      errorString.includes('Loading CSS chunk') ||
      
      // Network errors that might indicate stale chunks
      (errorString.includes('Failed to fetch') && errorString.includes('.js')) ||
      
      // Module loading errors
      errorMessage.includes('Loading chunk') ||
      errorMessage.includes('ChunkLoadError')
    );
  }
}